import Colors from "Constants/Color";
import { Modal, Table } from "react-bootstrap";

interface Bag {
    inventory_item_id: string | number;
    bag_no: string;
    available_quantity: number;
    issue_quantity: number;
}

interface ViewBagsModalProps {
    show: boolean;
    handleClose: () => void;
    bags: Bag[];
}

const ViewBagsModal: React.FC<ViewBagsModalProps> = ({
    show,
    handleClose,
    bags = []
}) => {
    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header className="border-0">
                <Modal.Title className="fw-bold">Added Bags</Modal.Title>
                <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleClose}
                />
            </Modal.Header>
            <hr />
            <Modal.Body>
                {bags.length === 0 ? (
                    <div className="text-center py-4 text-muted">
                        No bags added.
                    </div>
                ) : (
                    <Table responsive className="align-middle">
                        <thead className="table-light border-bottom">
                            <tr>
                                <th style={{ minWidth: 70 }} className="py-3 px-3">
                                    Sr No.
                                </th>
                                <th style={{ minWidth: 200 }} className="py-3 px-3">
                                    Bag No.
                                </th>
                                {/* <th style={{ minWidth: 200 }} className="py-3 px-3">
                                    Available Quantity
                                </th> */}
                                <th style={{ minWidth: 200 }} className="py-3 px-3">
                                    Issue Quantity
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {bags.map((bag, idx) => (
                                <tr key={idx} className="border-bottom">
                                    <td className="py-2 px-3">{idx + 1}</td>
                                    <td className="py-2 px-3">{bag.bag_no || "-"}</td>
                                    {/* <td className="py-2 px-3">{bag.available_quantity || "-"}</td> */}
                                    <td className="py-2 px-3">{bag.issue_quantity || "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ViewBagsModal;






